const ALLOWACE_DEG = 45;
const PI_DEG = 180;

export default ({ beta, gamma }) => { 
    return (PI_DEG - ALLOWACE_DEG < beta || beta < ALLOWACE_DEG - PI_DEG)
        &&(-ALLOWACE_DEG < gamma && gamma < ALLOWACE_DEG)
}